import React from 'react';

// definition of the global variable FastbetCartContext: it is structured into Main.js with useState()
const FastbetCartContext = React.createContext(null);

export default FastbetCartContext;